import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Menu } from "antd"
import { Link } from "react-router-dom"
import MenuAPI from '@/API/menu'
import { setMenus } from '@/store/actionCreators'
import { connect } from 'react-redux'

const Contain = styled.div`
  background-color: #001529;
  overflow: scroll;
`

const MyMenu = styled(Menu)`
  .ant-menu-item{
    margin:0 !important;
    height:56px !important;
    line-height:56px !important;
  }
`

class MenuTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus:[],
      selected:null
    }
  }
  static propTypes = {
    className: PropTypes.string
  }

  componentDidMount() {
    MenuAPI.getUserMenu().then((res)=>{
      if(!res){
        return
      }
      this.setState({menus:res.menus||[]})
    }).catch((err)=>{
      console.log(err)
    })
    // if(process.env.NODE_ENV==='development'){
    //   LogAPI.login()
    // }
  }
  componentDidUpdate() {
    this.selectMenu()
  }
  selectMenu=()=>{
    const {pathname}=this.props
    const {selected}=this.state||{}
    let menu=this.state.menus.find((item)=>{
      return item.url===pathname.slice(1)
    })
    if(menu&&!(selected&&selected===menu.id.toString())){
      this.setState({selected:menu.id.toString()})
    }
  }
  render() {
    const {selected}=this.state;
    console.log(this.state.menus,'this.state.menus')
    let userMessage = this.state.menus;    
    // this.props.curRoleId === 3 && this.props.curOperator === 'MYDG'||this.props.curRoleId === 3 && this.props.curOperator === 'THAIS'||this.props.curRoleId === 3 && this.props.curOperator === 'THDTAC'||this.props.curRoleId === 3 && this.props.curOperator === 'THTRUE'
    if (!((this.props.curRoleId === 3 && this.props.curOperator === 'INFK')
     || this.props.curRoleId === 1 || this.props.curRoleId === 2)) {      
      userMessage = this.state.menus.filter(item=> item.id !== 4)      
    }   
    return (
      <Contain className={this.props.className}>
        <MyMenu mode="inline" theme="dark" selectedKeys={[selected]}>
          {userMessage.map((item)=>{           
            return (
              <Menu.Item key={item.id} >
                <Link to={item.url}>
                  <span>{item.name}</span>
                </Link>
              </Menu.Item>
            )
          })}
        </MyMenu>
      </Contain>
    )
  }
}

const mapDispatchToProps = { setMenus }


const mapStateToProps = (state)=>{
  return {
    roles:state.roles,
    curRoleId:state.roleId,
    curOperator:state.operator
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(MenuTab)
